<template>
  <div id="questionsbody">
    <vignette :icon="'fa-tasks'" :color="'#FF8746FF'" v-if="!isMobile"></vignette>
    <div id="questionslist" v-if="!isMobile">
      <transition-group tag="div" name="slidefade" v-for="(item, index) in score" :key="index" appear>
        <div class="questionitem smallRoundAngles paddingRound slidefade-item plainTheme"
             :key="index">
          <span style="font-size: 0.9em;" class="line-clamp clamp1">{{questions[index].question}}</span>

          <span v-if="item === 'correct'" class="vocabPoints">
            +10pts
          </span>
          <i class="fa-duotone fa-circle-xmark" style="--fa-secondary-opacity: 1.0; --fa-primary-color : var(--goalBackground3);--fa-secondary-color: #ff5972;" v-else></i>
        </div>
      </transition-group>
    </div>
    <div id="questionscontent" :class="!isMobile?'navTheme':''">
      <question
          v-bind="questions[currentQuestion-1]"
          :key="currentQuestion"
          @sendAnswer="addAnswer" v-if="loaded"
      ></question>
      <loading-logo v-else>
      </loading-logo>
    </div>



  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import {API_URL} from "@/App";
import {lock} from "@/main";
import axios from "axios";

export default {
  name: "questions",
  components: {
    LoadingLogo: () => import(/* webpackPrefetch: true */ '@/components/loadingLogo.vue'),
    Vignette: () => import(/* webpackPrefetch: true */ '@/components/vignette.vue'),
    question: () => import(/* webpackPrefetch: true */ '@/components/question.vue')

  },

  props: {
    episodeId: Number
  },

  created() {
    this.fetch(this.episodeId)
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'states',
        'profile'
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
    ]),
  },

  methods: {
    ...mapActions('global', [
      'set_appStep',
      'set_carousselNavTo',
      'set_carousselNavTransition',
      'set_dataReload',
    ]),

    fetch(episodeId) {
      let token = "";
      const url = `${API_URL}/api/questions/` + episodeId + '/'
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          token = authResult.accessToken;

          axios.get(url, {headers: {Authorization: `Bearer ${token}`}})
              //this.$http.get('http://localhost:8000/api/episode/' + episode.id + '/')
              .then(response => {
                return response.data;
              })
              .then(data => {
                    this.questions = data;
                    this.loaded = true;
                  }
              );
        }
        else {
          console.log(error)
        }
      });
    },

    addAnswer(answer) {
      this.score.push(answer);
      if(this.score.length >= this.questions.length) {
        this.returnMenu()
      }
      else {
        this.currentQuestion++;
      }
    },

    returnMenu: function () {
      if(!this.$isDebug) {
        gtag('event', 'Questions', {
          'event_category': 'Session'
        })

        fbq('track', 'Questions Finished');
      }
      let score = this.getFinalScore()
      this.profile.datas.points += 10* score
      this.currentEpisodeData.user_episode.uq_check = true
      this.currentEpisodeData.user_episode.uq_score = score
      if (this.currentEpisodeData.user_episode.watch_check &&
          this.currentEpisodeData.user_episode.learn_check && this.currentEpisodeData.user_episode.uq_check) {
        this.currentEpisodeData.user_episode.check = 2
      }
      let payload = {
        "uq_check" : this.currentEpisodeData.user_episode.uq_check,
        "uq_score" : this.currentEpisodeData.user_episode.uq_score
      }
      const url = `${API_URL}/api/auth0userepisode/` + this.currentEpisodeData.id  + '/'
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then((response) => {
                // Données à changer en front-end
                // score de la saison
                // Score global
                // Episode : score questionnaire, check questionnaire, check global
                this.set_dataReload()
              })
        }
        else {
          console.log(error)
        }
      })
      this.set_carousselNavTo(1)
      this.set_appStep(this.states.MENU)
      window.setTimeout( () =>{this.set_carousselNavTransition(true)
      }, 50);
    },

    getFinalScore() {
      let score = 0;
      this.score.forEach((item) => {
        if(item === 'correct') {
          score ++;
        }
      })
      return score;
    }
  },

  data() {
    return {
      questions: [],
      score: [],
      loaded: false,
      currentQuestion: 1,
      finished: false
    }
  }
}
</script>

<style scoped>

#questionsbody{
  display: grid;
  grid-template-columns: 2fr 4fr;
  grid-template-rows: auto 1fr;
  padding: 1vw;
  grid-gap: 1vw;
  /*height: calc(100% - 2vw);*/
  flex-grow: 1;
}

#questionslist{
  grid-column: 1/2;
  grid-row: 2/3;
  border-radius: 1vw;
  padding: 0.5vw;
  max-height: 100%;
  height: 100%;

  flex-direction: column;
  align-content: center;
}

.questionitem{
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  font-weight: bold;
  margin-bottom: 0.3vw;
  z-index: 4;
}

#questionscontent{
  grid-column: 2/3;
  grid-row: 1/3;
  position: relative;
  border-radius: 1vw;
}

.title {
  text-align: center;
}

.menu {
  width: 30%;
  justify-self: center;
}

.modeOption {
  margin: 2vw;
  padding-bottom: 0px;
  padding-right: 0px;
  border: 1px solid whitesmoke;
}

.modeOption:hover {
  box-shadow: 0.5vw 0.5vw 1px 1px;
}

.modeDescription {
  display: flex;
  margin-bottom: 0px;
  margin-right: 0px;
  border-top-right-radius: 0px;
  font-style: italic;
}

.vocabPoints{
  font-size: 0.6em;
  padding: 0.12vw 0.25vw 0.12vw 0.25vw;
  background-color: #98FF7EF5;
  color: var(--standardColor);
  border-radius: 2vw;
}

.slidefade-item {
  transition: all 1s;
}

.slidefade-enter {
  opacity: 0;
  transform: translateX(2vw);
}

.slidefade-leave-active {
  position: absolute;
}

@media screen and (max-device-width: 767px) {

  #questionsbody{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    padding: 3vw;
    height: calc(100% - 6vw);
    min-height: 75vh;
  }
  #penduexplanation{
    grid-column: 1/2;
    grid-row: 1/2;
    border-radius: 0;
    height: min-content;
    padding: 0.5vw;
    border-bottom: 0.1vw solid #88888888;
    /*border-radius: 1vw;*/
  }

  #questionscontent{
    grid-column: 1/2;
    grid-row: 2/3;
    border-radius: 0;
  }

  #questionslist{
    border-radius: 4vw;
    padding: 2vw;
  }

  .modeOption {
    margin: 5vw;
  }

}

</style>